﻿'use strict';

angular.module('ntmApp')
  .filter('trustAsHtml', ['$sce', function ($sce) {

      return function (input) {
          return $sce.trustAsHtml(input);
      };
  }]);